import React from 'react';
import {
    Create, SimpleForm,
    ReferenceInput, AutocompleteInput,
} from 'react-admin';

import { required } from '../../util/fieldValidation';
import { parse } from 'query-string';

const PartnerClassesCreate = (props) => {
    // Read the partnerid from the location which is injected by React Router and passed to our component by react-admin automatically
    const { partnerid: partner_id_string } = parse(props.location.search);
    const PartnerID = partner_id_string ? parseInt(partner_id_string, 10) : 0;
    const redirect = PartnerID ? `/partners/${PartnerID}/show/courses` : false;

    return (
        <Create {...props}>
            <SimpleForm
                submitOnEnter={false}
                defaultValue={{PartnerID}}
                redirect={redirect}
            >
                <ReferenceInput
                    source='PartnerID'
                    reference='partners'
                    validate={[required()]}
                    perPage={1}
                    filter={{ Active: true, ids: [PartnerID] }}
                >
                    <AutocompleteInput optionText='PartnerName' />
                </ReferenceInput>
                <ReferenceInput
                    source='ClassTypeID'
                    reference='courses'
                    validate={[required()]}
                    sort={{ field: 'ClassName', order: 'ASC' }}
                    perPage={1000}
                    filter={{ Active: true }}
                    filterToQuery={searchText => ({ ClassName_like: searchText })}
                >
                    <AutocompleteInput optionText='ClassName' />
                </ReferenceInput>
            </SimpleForm>
        </Create>
    );
};
export default PartnerClassesCreate;